module.exports = "<div class=\"small-spinner\">\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/olycommon/loading-spinner/small-spinner.component.html
// module id = 625
// module chunks = 1